<template>
    <div
        @keydown.down.prevent.stop="goToNextOption"
        @keydown.up.prevent.stop="goToPreviousOption"
    >
        <slot />
    </div>
</template>

<script>
    export default {
        inject: ['state'],

        data: () => ({
            focusedIndex: null,
        }),

        methods: {
            focus() {
                const options = this.options();

                if (!options.length) {
                    return;
                }

                const selectedElement = options.find(element => {
                    return element.dataset.selected === 'true';
                });

                this.focusElement(selectedElement || options[0]);
            },

            focusElement(element, direction = 'down') {
                const options = this.options();
                const allDisabled = options.every(option => option.getAttribute('aria-disabled'));
                let index = options.findIndex(option => option.id === element.id);

                if (allDisabled) {
                    return;
                }

                if (element.getAttribute('aria-disabled')) {
                    if (direction === 'down') {
                        index++;

                        if (!options[index]) {
                            this.goToFirstOption('down');
                            return;
                        }
                    } else if (direction === 'up') {
                        index--;

                        if (!options[index]) {
                            this.goToLastOption('up');
                            return;
                        }
                    } else {
                        return;
                    }

                    this.focusElement(options[index], direction);
                    return;
                }

                element.scrollIntoView({ block: 'nearest' });
                element.focus();

                this.focusedIndex = index;
            },

            goToPreviousOption() {
                const options = this.options();

                if (this.focusedIndex === null) {
                    this.focusElement(options[0], 'up');
                    return;
                }

                if (this.focusedIndex <= 0) {
                    this.goToLastOption('up');
                    return;
                }

                this.focusElement(options[this.focusedIndex - 1], 'up');
            },

            goToNextOption() {
                const options = this.options();

                if (this.focusedIndex === null) {
                    this.focusElement(options[0], 'down');
                    return;
                }

                if (this.focusedIndex >= options.length - 1) {
                    this.goToFirstOption('down');
                    return;
                }

                this.focusElement(options[this.focusedIndex + 1], 'down');
            },

            goToFirstOption(direction) {
                this.focusElement(this.options()[0], direction);
            },

            goToLastOption(direction) {
                const options = this.options();
                this.focusElement(options[options.length - 1], direction);
            },

            options() {
                let children = [...this.$el.children];

                if (this.state.isGrouped && children.length) {
                    children = children.reduce((options, group) => {
                        return options.concat([...group.children]);
                    }, []);
                }

                return children.filter(child => {
                    return child.dataset.option === 'true';
                });
            },
        },
    };
</script>
